import { render } from "./VenueInput.vue?vue&type=template&id=aabf4450&scoped=true"
import script from "./VenueInput.vue?vue&type=script&lang=js"
export * from "./VenueInput.vue?vue&type=script&lang=js"

import "./VenueInput.vue?vue&type=style&index=0&id=aabf4450&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aabf4450"]])

export default __exports__